import { Component, Output, ChangeDetectorRef, ViewChild, EventEmitter, ViewChildren, QueryList, ElementRef, Injector } from '@angular/core'; import { ConfirmationService } from 'primeng/api';
import { toObservable } from '@angular/core/rxjs-interop';
import { environment } from 'src/environments/environment'; import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { MessageService } from 'primeng/api'; import { Subject, takeUntil, forkJoin, filter } from 'rxjs'; import { LiveShopService } from 'src/app/services/liveshop.service';
import { Input, OnChanges, SimpleChanges } from '@angular/core'; import { PedidosService } from 'src/app/services/pedidos.service'; import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { FeedService, Feed, User, ListFeedsPayload } from 'src/app/services/feed.service'; import { Asset, Item } from 'src/app/models/liveshop';
import { Media } from 'src/app/models/liveshop'; import { DateTime } from 'luxon'; import { Share } from '@capacitor/share';
import { AuthHeaderService } from 'src/app/services/auth-header.service';
import { AccountSelectorComponent } from 'src/app/components/account-selector/account-selector.component';
import { UsageRightsComponent } from 'src/app/components/usage-rights/usage-rights.component';

import { Capacitor } from '@capacitor/core';
import { FileTransfer } from '@capacitor/file-transfer';
import { Filesystem, Directory } from '@capacitor/filesystem';
import { ProductCatalogCacheService } from 'src/app/services/product-catalog-cache.service';
import { transformProdutoShopify } from 'src/app/models/product-picklist.model';

@Component({
  selector: 'app-slicks-data-view',
  templateUrl: './slicks-data-view.component.html',
  styleUrls: ['./slicks-data-view.component.scss']
})
export class SlicksDataViewComponent {

  @ViewChild(AccountSelectorComponent)
  accountSelector!: AccountSelectorComponent;

  @ViewChild('usageRightsRef') usageRightsRef?: UsageRightsComponent;

  @Input() filteredAssets: any[] = [];
  groupedAssets: any[] = [];

  get totalPaisSelecionados(): number {
    return this.selectedItems.filter(item => item.parent_id === null).length;
  }
  getCleanedTags(feed: any): string[] {
    return (feed?.type || '')
      .split(',')
      .map((t: any) => t.trim())
      .filter((t: any) => !t.startsWith('#'));
  }
  onImageError(event: any) {
    event.target.src = '/assets/rosto.jpg';
  }
  onImageError2(event: any, item: any) {

    console.log(item)
    event.target.src = '/assets/rosto.jpg';
  }

  formatTimestamp(value?: string | null): string {
    if (!value) return 'Agora mesmo';

    let postDate = DateTime.fromFormat(value, 'yyyy-MM-dd HH:mm:ss', { zone: 'utc' });

    if (!postDate.isValid) {
      postDate = DateTime.fromISO(value, { setZone: true });
    }

    if (!postDate.isValid) {
      return 'Data inválida';
    }

    const now = DateTime.now();
    const diff = now.diff(postDate, ['years', 'months', 'days', 'hours', 'minutes']).toObject();

    if (diff.years && diff.years >= 1) {
      const years = Math.floor(diff.years);
      return `${years} ano${years > 1 ? 's' : ''} atrás`;
    }
    if (diff.months && diff.months >= 1) {
      const months = Math.floor(diff.months);
      return `${months} mês${months > 1 ? 'es' : ''} atrás`;
    }
    if (diff.days && diff.days >= 1) {
      const days = Math.floor(diff.days);
      return `${days} dia${days > 1 ? 's' : ''} atrás`;
    }
    if (diff.hours && diff.hours >= 1) {
      const hours = Math.floor(diff.hours);
      return `${hours} hora${hours > 1 ? 's' : ''} atrás`;
    }
    if (diff.minutes && diff.minutes >= 1) {
      const minutes = Math.floor(diff.minutes);
      return `${minutes} minuto${minutes > 1 ? 's' : ''} atrás`;
    }

    return 'Agora mesmo';
  }






  @Input() sortField!: string;
  @Input() sortOrder!: number;

  @Input() typeOptions: any[] = [];
  @Input() selectedType: any;
  @Output() selectedTypeChange = new EventEmitter<any>();
  messageWithChip = `
  Gostaríamos de usar este conteúdo em nossos materiais de divulgação.
  Se estiver de acordo, por favor responda com
  <span contenteditable="false" style="
    display: inline-block;
    background: #d1e7dd;
    color: #0f5132;
    padding: 0.2rem 0.6rem;
    border-radius: 16px;
    font-weight: bold;
  ">#sim</span>
  para autorizar o uso. Caso não autorize, responda com
  <span contenteditable="false" style="
    display: inline-block;
    background: #f8d7da;
    color: #842029;
    padding: 0.2rem 0.6rem;
    border-radius: 16px;
    font-weight: bold;
  ">#nao</span>.
`;
  simObrigatorioRemovido = false;

  onContentChange(event: Event): void {
    const content = (event.target as HTMLElement).innerHTML;
    this.simObrigatorioRemovido = !content.includes('#sim');
  }
  @Input() statusOptions: any[] = [];
  @Input() selectedStatus: any;
  @Output() selectedStatusChange = new EventEmitter<any>();

  @Input() rangeDates: any;
  @Output() rangeDatesChange = new EventEmitter<any>();

  @Input() searchTerm: string = '';
  @Output() searchTermChange = new EventEmitter<string>();

  @Output() onTypeSelect = new EventEmitter<void>();
  @Output() onStatusSelect = new EventEmitter<void>();
  @Output() onDateSelect = new EventEmitter<void>();
  @Output() onFilterSlicks = new EventEmitter<any>();
  @Output() clearFilter = new EventEmitter<void>();

  @Input() sourceOptions: any[] = [];
  @Input() selectedSources: string[] = [];
  @Output() selectedSourcesChange = new EventEmitter<string[]>();
  @Output() onSourceSelect = new EventEmitter<void>();

  @Input() mediaTypeOptions: any[] = [];
  @Input() selectedMediaTypes: string[] = [];
  @Output() selectedMediaTypesChange = new EventEmitter<string[]>();
  @Output() onMediaTypeChange = new EventEmitter<void>();

  @Input() usageRightsOptions: any[] = [];
  @Input() selectedUsageRights: string[] = [];
  @Output() selectedUsageRightsChange = new EventEmitter<string[]>();
  @Output() onUsageRightsChange = new EventEmitter<void>();

  private pendingUid: string = '';
  displayConfirmDialog: boolean = false;
  isSharing: boolean = false;
  uidSeletedTemplate: string = '';
  displayDialogTemplate: boolean = false;
  displayDialogSidebar: boolean = false;
  displayDialog: boolean = false;
  assets: any[] = [];
  OriginalAssets: any[] = [];
  constructor(
    private router: Router,
    private errorHandler: ErrorHandlerService,
    private authHeaderService: AuthHeaderService,
    private route: ActivatedRoute,
    private pedidosService: PedidosService,
    private cdr: ChangeDetectorRef,
    private feedService: FeedService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private liveShopService: LiveShopService,
    private catalogCache: ProductCatalogCacheService,
    private injector: Injector
  ) {
    console.log('[Capacitor] referenced in SlicksDataViewComponent');
    }

  isMobile = false;

  feed_uid: string | null = null;

  // SSAPP-perf: selectedFilterChips (getter, reavaliado em toda change
  // detection — inclusive ao só abrir/fechar o dialog de filtros, que não
  // muda nenhum desses *Options) fazia um .find() linear em cada uma dessas
  // listas por valor selecionado. Em lojas com muitos produtos/tags essas
  // listas vêm com "TODOS os itens da loja" (mesmo padrão de custo já
  // documentado em groupAssetsByParent() abaixo) — Map construído só quando
  // a lista de fato muda (ngOnChanges por referência) deixa a busca O(1).
  private statusOptionsMap = new Map<string, any>();
  private sourceOptionsMap = new Map<string, any>();
  private mediaTypeOptionsMap = new Map<string, any>();
  private usageRightsOptionsMap = new Map<string, any>();
  private feedOptionsMap = new Map<string, any>();
  private tagOptionsMap = new Map<string, any>();
  private productOptionsMap = new Map<string, any>();

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['statusOptions']) this.statusOptionsMap = new Map((this.statusOptions || []).map(o => [o.value, o]));
    if (changes['sourceOptions']) this.sourceOptionsMap = new Map((this.sourceOptions || []).map(o => [o.value, o]));
    if (changes['mediaTypeOptions']) this.mediaTypeOptionsMap = new Map((this.mediaTypeOptions || []).map(o => [o.value, o]));
    if (changes['usageRightsOptions']) this.usageRightsOptionsMap = new Map((this.usageRightsOptions || []).map(o => [o.value, o]));
    if (changes['tagOptions']) this.tagOptionsMap = new Map((this.tagOptions || []).map(o => [o.value, o]));
    if (changes['productOptions']) this.productOptionsMap = new Map((this.productOptions || []).map(o => [o.value, o]));

    if (changes['feedOptions']) {
      this.feedOptionsMap = new Map((this.feedOptions || []).map(o => [o.value, o]));
      if (this.feed_uid) {
        this.setFeedUidFromUrl(); // reaplica se `feedOptions` vier depois
      }
    }
    if (changes['filteredAssets']) {
      this.groupAssetsByParent();
    }
  }
  groupAssetsByParent(): void {
    if (!Array.isArray(this.filteredAssets)) {
      this.groupedAssets = [];
      return;
    }

    // O agrupamento + sort roda sobre TODOS os itens da loja (a rota
    // /videoshopping/asset não pagina) — em lojas com muitos slicks isso
    // custa dezenas de ms. Como isso é disparado de forma síncrona pelo
    // ngOnChanges assim que o componente pai (lives.component) atribui
    // `filteredAssets`, sem adiar isso aqui a troca de rota pra /slicks
    // trava até o cálculo terminar, mesmo com o skeleton do lives.component
    // já tendo sumido. O setTimeout(0) devolve o controle pro browser pintar
    // (e o skeleton próprio deste componente, controlado por
    // `isLoadingSkeleton`, cobre visualmente essa janela).
    setTimeout(() => {
      const flat = this.filteredAssets.flatMap(g => g.items || []);
      this.groupedAssets = this.groupAssetsByParentId(flat);
    }, 0);
  }
  groupAssetsByParentId(items: Item[]): any[] {
    const groupedResults: any[] = [];

    const groupsByParentId = new Map<string, Item[]>();
    const orphanItems: Item[] = [];

    for (const item of items) {
      if (item.parent_id !== null && item.parent_id !== undefined) {
        const key = String(item.parent_id);
        if (!groupsByParentId.has(key)) {
          groupsByParentId.set(key, []);
        }
        groupsByParentId.get(key)!.push(item);
      } else if (!item.media_id && !item.parent_id) {
        orphanItems.push(item); // item totalmente independente
      }
    }

    for (const [parentId, groupItems] of groupsByParentId.entries()) {
      const parent = groupItems.find(i => String(i.media_id) === parentId) || groupItems[0];
      const children = groupItems.filter(i => i !== parent);

      groupedResults.push({
        ...parent,
        children: { data: children }
      });
    }

    for (const orphan of orphanItems) {
      groupedResults.push({ ...orphan, children: { data: [] } });
    }

    // Ordena resultado final: pin em primeiro, depois por created_at do pai
    groupedResults.sort((a, b) => {
      if (!!a.media?.pin) return -1;
      if (!!b.media?.pin) return 1;

      const aDate = new Date(a.created_at ?? a.post_timestamp ?? 0).getTime();
      const bDate = new Date(b.created_at ?? b.post_timestamp ?? 0).getTime();
      return bDate - aDate; // mais recente primeiro
    });
    this.isLoadingSkeleton = false;
    return groupedResults;
  }


  getSlideStatus(item: any): number {
    const uid = item?.content?.uid;
    if (!uid) return 0;

    const swiperEl = document.querySelector(`[data-uid="${uid}"]`) as any;
    if (!swiperEl || !swiperEl.swiper) return item.media?.status ?? 0;

    const realIndex = swiperEl.swiper.realIndex;
    if (realIndex === 0) return item.media?.status ?? 0;

    const child = item.children?.data?.[realIndex - 1];
    return child?.media?.status ?? 0;
  }


  isNative: boolean = false;
  avatarUrl: string | null = null;
  ngOnInit() {
    this.isMobile = window.innerWidth <= 768;
    this.isNative = Capacitor.isNativePlatform();

    this.feed_uid = this.route.snapshot.queryParamMap.get('feed_uid');

    if (this.feed_uid && this.feedOptions?.length) {
      this.setFeedUidFromUrl(); // já tenta aplicar se opções já estiverem prontas
    }

    const savedAvatar = localStorage.getItem('avatarUrl');
    this.avatarUrl = savedAvatar ?? 'assets/layout/images/avatar.png';


    // 🟢 Recupera os dados da loja
    const storeData = localStorage.getItem('store_data');
    if (storeData) {
      const parsed = JSON.parse(storeData);
      this.storeName = parsed.store_name;
      this.storeDomain = parsed.store_domain;
    }

    this.checkStoreIntegration();
  }

  // Ícone de sacola (associar produtos) só aparece se a loja tiver Shopify ou
  // Nuvemshop conectado — mesma checagem que app-product-picklist já faz
  // internamente, mas aqui é feita uma vez pra loja inteira (não por item).
  hasStoreIntegration = false;
  private checkStoreIntegration(): void {
    const hasActiveApp = (response: any): boolean => {
      const apps = response?.store_apps;
      if (!Array.isArray(apps) || !apps.length) return false;
      return apps.some((app: any) => {
        const status = (app?.active ?? app?.status ?? '').toString().toLowerCase();
        return status === 'active' || status === '1' || status === 'true';
      });
    };

    Promise.all([
      this.pedidosService.getAppsStore('shopify').toPromise(),
      this.pedidosService.getAppsStore('nuvemshop').toPromise(),
    ]).then(([shopifyResponse, nuvemshopResponse]) => {
      this.hasStoreIntegration = hasActiveApp(shopifyResponse) || hasActiveApp(nuvemshopResponse);
      this.cdr.detectChanges();
    }).catch((err) => {
      console.error('Erro ao checar integração de loja:', err);
    });
  }

  // Sidebar de associação de produtos (app-product-picklist) — abre a partir
  // do ícone de sacola no pill de status. Busca o asset completo só pra
  // pegar os produtos já associados (mesma rota que slick-detail usa) e salva
  // via updateAssetProducts, endpoint dedicado que não mexe em mais nada do
  // slick.
  productSidebarVisible = false;
  productSidebarLoading = false;
  productSidebarTarget: any[] = [];
  private productSidebarUid: string | null = null;
  private productSidebarItem: any = null;

  getProductCount(item: any): number {
    return item?.content?.cta?.components?.products?.items?.length ?? 0;
  }

  openProductSidebar(item: any): void {
    const uid = item?.content?.uid;
    if (!uid) return;

    this.productSidebarUid = uid;
    this.productSidebarItem = item;
    this.productSidebarTarget = [];
    this.productSidebarVisible = true;
    this.productSidebarLoading = true;

    // Cache-first com ETag (src/app/core/http-cache).
    const assetResource = this.liveShopService.detailAssetRevalidated(uid);

    toObservable(assetResource.data, { injector: this.injector }).pipe(
      filter((resp): resp is any => resp !== null),
      takeUntil(this.destroy$)
    ).subscribe(resp => {
        const items = resp?.items?.[0]?.content?.cta?.components?.products?.items ?? [];
        // Produto já salvo volta com o campo `image` (não `thumbnail`, que só
        // existe pros recém-adicionados vindos do catálogo) — mesmo fallback
        // que slick-detail já faz em normalizeProductData().
        this.productSidebarTarget = items.map((p: any) => ({ ...p, thumbnail: p.thumbnail || p.image || '' }));
        this.productSidebarLoading = false;
        this.cdr.detectChanges();
    });

    toObservable(assetResource.error, { injector: this.injector }).pipe(
      filter((err): err is any => err !== null),
      takeUntil(this.destroy$)
    ).subscribe(err => {
        this.productSidebarLoading = false;
        this.errorHandler.handle(err, 'Falha ao carregar produtos do slick.');
        this.cdr.detectChanges();
    });
  }

  closeProductSidebar(): void {
    this.productSidebarVisible = false;
    this.productSidebarUid = null;
    this.productSidebarItem = null;
    this.productSidebarTarget = [];
  }

  onProductSidebarChanged(): void {
    if (!this.productSidebarUid) return;
    this.liveShopService.updateAssetProducts(this.productSidebarUid, this.productSidebarTarget).subscribe({
      next: () => {
        // Sincroniza o item da listagem pra o badge de contagem refletir na hora.
        if (this.productSidebarItem?.content?.cta?.components?.products) {
          this.productSidebarItem.content.cta.components.products.items = this.productSidebarTarget;
          this.cdr.detectChanges();
        }
        this.messageService.add({ severity: 'success', summary: 'Produtos atualizados', detail: 'Associação de produtos salva com sucesso.' });
      },
      error: (err: any) => {
        this.errorHandler.handle(err, 'Falha ao salvar produtos do slick.');
      }
    });
  }
  storeName?: string;
  storeDomain?: string;
  private clearFeedUidFromUrl(): void {
    const currentParams = { ...this.route.snapshot.queryParams };

    if (!currentParams['feed_uid']) {
      return; // já está limpo, não navega de novo
    }

    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { feed_uid: null },
      queryParamsHandling: 'merge'
    });
  }
  private setFeedUidFromUrl() {
    const found = this.feedOptions.find(opt => opt.value === this.feed_uid);
    if (found) {
      this.selectedFeeds = [this.feed_uid!];
      // setTimeout: setFeedUidFromUrl roda de dentro de ngOnInit/ngOnChanges —
      // ou seja, no meio do próprio ciclo de change detection que o Angular
      // está usando pra checar os bindings deste componente (inclusive
      // [filteredAssets], setado pelo pai). handleFeedChange emite
      // onFeedSelect, que o lives.component ouve de forma síncrona e reatribui
      // filteredAssets ali mesmo — depois que esse binding já tinha sido
      // checado nesse ciclo, causando ExpressionChangedAfterItHasBeenChecked.
      // Empurrar pro próximo tick resolve isso da mesma forma que
      // groupAssetsByParent já faz aqui perto.
      setTimeout(() => {
        this.handleFeedChange({ value: this.selectedFeeds }); // dispara o filtro
      });
    }
  }
  getIconType(type: string | null): string {
    if (!type) {
      return ''; // Retorna o ícone padrão se type for null
    }

    // Normaliza o tipo para minúsculas para simplificar a comparação
    const normalizedType = type.toLowerCase();

    switch (normalizedType) {
      case 'live':
        return 'pi pi-video'; // Retorna o ícone para live
      case 'shorts':
        return 'pi pi-fw pi-chevron-circle-right'; // Retorna o ícone para shorts
      default:
        return ''; // Retorna um ícone padrão se nenhum caso corresponder
    }
  }


  getSeverityFilterTypeLive(value: string): string {
    if (value === 'live') {
      return 'info';
    } else if (value === 'shorts') {
      return 'success';
    } else {
      return 'neutral'; // ou qualquer outro valor padrão de severidade
    }
  }

  getSeverityStatusDropdown(status: any): string {
    switch (status) {
      case 'publicado':
        return 'success';
      case 'naoPublicado':
        return 'warning';
      case 'agendado':
        return 'danger';
      default:
        return '';
    }
  }


  replaceDomain(url: string | undefined): string | undefined {
    const s3Domain = 'https://krabo163508-dev.s3.sa-east-1.amazonaws.com';
    const cloudFrontDomain = 'https://d2434dp583bttd.cloudfront.net';
    if (url && url.includes(s3Domain)) {
      return url.replace(s3Domain, cloudFrontDomain);
    }
    return url; // Retorna a URL original, que pode ser undefined
  }


  playVideo(videoElement: HTMLVideoElement) {
    if (this.shouldPlay) {
      videoElement.play().catch(e => {
        console.error("Erro ao tentar reproduzir o vídeo:", e);
      });
    }
  }

  startVideo(videoElement: HTMLVideoElement) {
    this.shouldPlay = true;
    // Limpa um timeout existente se houver
    clearTimeout(this.timeoutId);

    // Define um novo timeout para tocar o vídeo
    this.timeoutId = setTimeout(() => {
      this.playVideo(videoElement);
    }, 100);  // atraso de 100ms
  }


  resetVideo(videoElement: HTMLVideoElement) {
    this.shouldPlay = false;
    clearTimeout(this.timeoutId); // Cancela o timeout de play se ainda estiver pendente
    videoElement.pause();
    videoElement.currentTime = 0;
    videoElement.load();
  }

  getIconDuration(duration: number | null, stream_status: string | null): string {
    if (duration === null) {

      if (stream_status === null) {
        return '';
      }

      if (stream_status !== null) {

        if (stream_status == 'idle') {
          return '';
        }
        if (stream_status == 'disabled') {
          return '';
        }
        if (stream_status == 'active') {
          return 'pi pi-circle-fill custom-color';
        }

      }

    }

    // Se duration é null e não temos um stream_status válido, retorna "-"

    return 'pi pi-play';
  }

  formatDurationPill(duration: number | null, stream_status: string | null, type: string): string {
    if (duration === null || duration == 0 || type === 'live') {

      if (stream_status === null) {
        return 'Ativo';
      }

      if (stream_status !== null || duration == 0 || type === 'live') {

        if (stream_status == 'idle') {
          return 'Ativo';
        }
        if (stream_status == 'disabled') {
          return 'Desativado';
        }
        if (stream_status == 'active') {
          return 'Ao vivo';
        }
        if (stream_status == '') {
          return 'Ativo';
        }

      }

    }

    // Se duration é null e não temos um stream_status válido, retorna "-"
    if (duration === null) {
      return "-";
    }

    if (type !== 'live') {
      let hours = Math.floor(duration / 3600);
      let minutes = Math.floor((duration % 3600) / 60);

      if (hours == 0 && minutes == 0) {
        minutes = 1;
      }
      return `${hours.toString().padStart(2, '0')}h${minutes.toString().padStart(2, '0')}m`;
    }
    if (stream_status == 'idle') {
      return 'Ativo';
    }
    if (stream_status == 'disabled') {
      return 'Desativado';
    }
    if (stream_status == 'active') {
      return 'Ao vivo';
    }
    return "-";
  }

  getStatusText(status: number, dateFrom?: Date): string {
    const now = new Date();

    if (status === 1) {
      return 'Publicado';
    } else if (status === 0 && dateFrom && new Date(dateFrom) > now) {
      return 'Agendado';
    } else if (status === 0) {
      return 'Não Publicado';
    } else {
      return 'Desconhecido'; // ou qualquer valor padrão adequado
    }
  }

  getSeverityStatus(status: number, dateFromString?: string): string {
    const now = new Date(); // modificação
    let dateFrom = dateFromString ? new Date(dateFromString) : null;

    // Ajustar para a mesma zona horária, se necessário
    // Por exemplo, converter dateFrom para a zona horária local, se estiver em UTC
    // Isso depende de como você quer lidar com as zonas horárias

    if (status === 1) {
      //console.log('Returning publicado');
      return 'success';
    } else if (status === 0 && (!dateFrom || dateFrom > now)) {
      //console.log('Returning agendado');
      return 'danger';
    } else if (status === 0) {
      //console.log('Returning não publicado');
      return 'warning';
    } else {
      //console.log('Returning default');
      return ''; // Retorna um valor padrão caso não se encaixe nas condições
    }
  }

  getActionMenu(id: any, uid: any, title: string) {
    const item = this.findByUid(uid);
    const isDisabled = item?.source_id === 'up' || item?.source_id === 'tt' || item?.source_id === 'yt' || item?.feed_type == 'personal_midia';
    const isInstagramPostDisabled = item?.source_id === 'up';

    let watchPost = item?.source_id === 'tt' ? 'TiKTok' : 'Instagram';
    if (item?.source_id === 'tt') {
      watchPost = 'TiKTok';
    } else if (item?.source_id === 'yt') {
      watchPost = 'Youtube';
    } else {
      watchPost = 'Instagram';
    }

    return [
      { label: 'Editar', icon: 'pi pi-file-edit', command: () => this.editSlick(uid) },
      {
        label: 'Ver post no ' + watchPost,
        icon: 'pi pi-external-link',
        command: () => this.verPostNoInstagram(this.findByUid(uid)),
        disabled: isInstagramPostDisabled
      },
      { label: 'Download', icon: 'pi pi-download', command: () => this.download(uid) },
      { label: 'Ver analytics', icon: 'bi bi-graph-up', command: () => this.analytics(uid, title) },
      {
        label: 'Solicitar direitos autorais',
        icon: 'bi bi-c-circle',
        command: () => this.abrirDialogDireitos(this.findByUid(uid)),
        disabled: isDisabled
      },
      { label: 'Duplicar', icon: 'bi bi-clipboard', command: () => this.duplicar(uid) },
      { label: 'Atualizar Insights', icon: 'bi bi-clipboard', command: () => this.insights(item) },
      { label: 'Compartilhar', icon: 'pi pi-share-alt', command: () => this.share(uid) },
      { label: 'Deletar', icon: 'pi pi-trash', command: () => this.confirmDeletion(uid) },
    ];
  }

  insights(item: any): void {
    const uid = item?.content?.uid;
    const source = item?.source_id?.toLowerCase();

    if (!uid) return;

    this.displayAguarde = true;

    if (source === 'tt' || source === 'tiktok') {
      this.feedService.atualizarInsights(uid, 'tiktok').subscribe({ // passa 'tiktok' como origem
        next: (res) => { this.handleInsightsResponse(res, item); },
        error: (error) => { this.handleInsightsError(error); }
      });
    } else if (source === 'ig' || source === 'instagram') {
      this.feedService.atualizarInsights(uid, 'instagram').subscribe({ // passa 'instagram'
        next: (res) => { this.handleInsightsResponse(res, item); },
        error: (error) => { this.handleInsightsError(error); }
      });
    } else {
      this.messageService.add({
        severity: 'info',
        summary: 'Em breve',
        detail: 'Atualização de insights ainda não disponível para esta origem.',
      });
      this.displayAguarde = false;
    }
  }
  private handleInsightsResponse(res: any, item: any) {
    if (res?.insights) {
      item.insights = { ...item.insights, ...res.insights };
      this.cdr.detectChanges();
    }
    this.messageService.add({
      severity: 'success',
      summary: 'Insights atualizados',
      detail: res.message || 'Dados atualizados com sucesso.',
    });
    this.displayAguarde = false;
  }
  private handleInsightsError(error: any) {
    this.messageService.add({
      severity: 'error',
      summary: 'Erro',
      detail: error?.error?.message || 'Falha ao atualizar insights.',
    });
    this.displayAguarde = false;
  }



  duplicar(uid: string): void {
    const item = this.findByUid(uid);

    if (!item) {
      console.warn('❌ Item não encontrado com UID:', uid);
      return;
    }

    const isCarousel = item.children?.data?.length > 0;

    if (!isCarousel) {
      this.template(item.content?.uid); // chama template direto com uid do item
      return;
    }

    // Buscar o swiper manualmente via DOM
    const elements = document.querySelectorAll('[data-uid]');
    let swiperElement: any = null;

    elements.forEach((el: any) => {
      const swiperUid = el.getAttribute('data-uid');
      if (swiperUid === item.content?.uid) {
        swiperElement = el.swiper;
      }
    });

    if (!swiperElement) {
      console.warn('❌ Swiper não encontrado para UID (via DOM):', item.content?.uid);
      return;
    }

    const activeIndex = swiperElement.realIndex;
    const activeItem =
      activeIndex === 0 ? item : item.children?.data?.[activeIndex - 1];

    if (activeItem?.content?.uid) {
      this.template(activeItem.content.uid);
    } else {
      console.warn('❌ UID não encontrado para item ativo');
    }
  }


  template(uid: string) {
    this.templateClicked.emit(uid);
  }


  download(uid: string): void {
    const item = this.findByUid(uid);

    if (!item) {
      console.warn('❌ Item não encontrado com UID:', uid);
      return;
    }

    const isCarousel = item.children?.data?.length > 0;

    if (!isCarousel) {
      if (Capacitor.isNativePlatform()) {
        this.safeDownload(item.media);
      } else {
        console.log('ts2')
        this.safeDownload2(item.media);
      }
      return;
    }

    // Fallback via querySelectorAll caso @ViewChildren falhe
    const elements = document.querySelectorAll('[data-uid]');
    let swiperElement: any = null;

    elements.forEach((el: any) => {
      const uid = el.getAttribute('data-uid');
      if (uid === item.content?.uid) {
        swiperElement = el.swiper;
      }
    });

    if (!swiperElement) {
      console.warn('❌ Swiper não encontrado para UID (via DOM):', item.content?.uid);
      return;
    }

    const activeIndex = swiperElement.realIndex;
    const media =
      activeIndex === 0
        ? item.media
        : item.children?.data?.[activeIndex - 1]?.media;

    if (Capacitor.isNativePlatform()) {
      this.safeDownload(media);
    } else {
      this.safeDownload2(media);
    }


  }
  extractExtensionFromUrl(url: string, isVideo: boolean): string {
    try {
      const pathname = new URL(url).pathname; // Ex: /abc/file.mp4
      const lastSegment = pathname.split('/').pop(); // Ex: file.mp4
      if (lastSegment && lastSegment.includes('.')) {
        const ext = lastSegment.split('.').pop()?.split(/[?#]/)[0];
        if (ext) return ext;
      }
    } catch (e) {
      console.warn('❌ URL inválida para extrair extensão:', url);
    }

    // 🎯 Fallback com base no tipo real
    return isVideo ? 'mp4' : 'jpg';
  }


  async safeDownload(media: Media | undefined | null): Promise<void> {
    if (!media) {
      console.warn('❌ Mídia indefinida.');
      return;
    }

    const url = media.src || media.thumbnail;

    if (!url) {
      console.warn('❌ Nenhuma URL de mídia encontrada.');
      return;
    }

    const isVideo = !!media.src;
    const extension = this.extractExtensionFromUrl(url, isVideo);
    const filename = `slick-${Date.now()}.${extension}`;


    console.log('filename: ' + filename)

    if (Capacitor.isNativePlatform()) {
      try {
        // ✅ Pega caminho completo para salvar o arquivo
        const fileInfo = await Filesystem.getUri({
          directory: Directory.ExternalStorage,
          path: `Download/${filename}`,
        });

        // ✅ Faz o download usando caminho completo
        const resultFile = await FileTransfer.downloadFile({
          url,
          path: fileInfo.uri,
          progress: true,
        });

        console.log('✅ Arquivo salvo em:', resultFile.path);

        this.messageService.add({
          severity: 'success',
          summary: 'Download concluído',
          detail: `Arquivo salvo em Downloads`, // `Arquivo salvo em: ${resultFile.path}`
          life: 5000,
        });

      } catch (error: any) {
        this.errorHandler.handle(error, error?.message || 'Verifique permissões ou espaço disponível.');
      }
    } else {
      // Navegador: tenta fetch com blob, e se falhar, usa fallback direto
      try {
        const response = await fetch(url, { mode: 'cors' });

        if (!response.ok) throw new Error('Resposta inválida.');

        const blob = await response.blob();
        const blobUrl = URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.href = blobUrl;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(blobUrl);
      } catch (err) {
        console.warn('⚠️ Falha ao baixar via fetch (CORS?). Fazendo fallback para link direto...', err);

        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.target = '_blank';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);

        this.messageService.add({
          severity: 'warn',
          summary: 'Download com fallback',
          detail: 'O download foi iniciado sem confirmação por causa de restrição CORS.',
          life: 4000,
        });
      }
    }
  }


  async safeDownload2(media: Media | undefined | null): Promise<void> {
    if (!media) {
      console.warn('❌ Mídia indefinida.');
      return;
    }

    const originalUrl = media.src || media.thumbnail;

    if (!originalUrl) {
      console.warn('❌ Nenhuma URL encontrada.');
      return;
    }

    // 🔗 Cria a URL do backend com a URL original como query param
    const backendUrl = `${environment.apiBaseUrl}/api/auth/force-download?url=${encodeURIComponent(originalUrl)}`;

    // 🔄 Redireciona para o backend para iniciar download NATIVO com diálogo
    window.location.href = backendUrl;
  }



  private getCookie(name: string): string | null {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null; // não decodifica aqui — deixa pro headers
  }

  verPostNoInstagram(item: any): void {
    let link = null;
    let plataforma = (item.source_id || '').toLowerCase();

    if (plataforma === 'yt') {
      const mediaId = item.media_id || item.media?.media_id;
      if (mediaId) {
        link = `https://www.youtube.com/watch?v=${mediaId}`;
      }
    } else if (plataforma === 'ig') {
      link = item.permalink;
    } else if (plataforma === 'tt') {
      link = item.permalink; // Ou outro campo, se você salvar diferente para TikTok
    }

    if (!link) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Atenção',
        detail: 'Este item não possui um link para o post.'
      });
      return;
    }

    window.open(link, '_blank');
  }


  findByUid(uid: string): any {
    for (const parent of this.groupedAssets) {
      if (parent.content?.uid === uid) return parent;

      const match = parent.children?.data?.find((child: any) => child.content?.uid === uid);
      if (match) return match;
    }
    return null;
  }

  itemsButtons: any[] = [];
  getSeverity(type: string): string {
    if (type === 'live') return 'info';
    if (type === 'shorts') return 'success';
    return 'neutral';
  }
  @Input() isLoadingSkeleton: boolean = true;
  shouldPlay: boolean = false;
  timeoutId: any;
  editSlick(uid: string): void {
    const item = this.findByUid(uid);
    if (!item) {
      console.warn('❌ Item não encontrado com UID:', uid);
      return;
    }

    let uidParaEditar = item.content.uid;
    const isCarousel = item.children?.data?.length > 0;

    if (isCarousel) {
      const elements = document.querySelectorAll('[data-uid]');
      let swiperElement: any = null;

      elements.forEach((el: any) => {
        const elUid = el.getAttribute('data-uid');
        if (elUid === item.content?.uid) {
          swiperElement = el.swiper || el.__swiper__;
        }
      });

      if (!swiperElement) {
        console.warn('❌ Swiper não encontrado para UID:', uid);
        return;
      }

      const activeIndex = swiperElement.realIndex;

      if (activeIndex > 0) {
        const child = item.children?.data?.[activeIndex - 1];
        uidParaEditar = child?.content?.uid;
      }
    }

    this.redirectToSlickDetail(uidParaEditar);
  }

  redirectToSlickDetail(uuid: string): void {
    this.router.navigate(['/slick', uuid]);
  }
  @Output() solicitarFixar = new EventEmitter<string>();
  @Output() addSlick = new EventEmitter<void>();
  @Output() slickDeleted = new EventEmitter<number>();
  @Output() slicksDeleted = new EventEmitter<string[]>();
  fixarVideo(uid: string) {
    this.pendingUid = uid;
    this.displayConfirmDialog = true;
  }

  async share(uid: string) {
    const domainStore = localStorage.getItem('domain_store') || '';
    const subdomain = domainStore.split('.')[0] || '';
    let shareUrl = `${environment.frontendUrl}/${subdomain}?slick_id=${uid}`;
    console.log('tsttttsdsss ')
    // Garante que só adiciona https:// se estiver faltando
    if (!/^https?:\/\//i.test(shareUrl)) {
      shareUrl = 'https://' + shareUrl;
    }

    // Remove qualquer http:// ou https:// do começo
    shareUrl = shareUrl.replace(/^https?:\/\//i, '');

    // Adiciona https:// somente uma vez
    shareUrl = 'https://' + shareUrl;

    if (Capacitor.isNativePlatform()) {
      // App nativo
      try {
        await Share.share({
          title: 'Compartilhar Link',
          text: 'Veja esse conteúdo!',
          url: shareUrl,
          dialogTitle: 'Compartilhar via'
        });
      } catch (err) {
        console.error('Erro ao compartilhar:', err);
      }
    } else if (navigator.share) {
      console.log('tstttt ' + shareUrl)
      // Navegador moderno
      try {
        await navigator.share({
          title: 'Compartilhar Link',
          url: shareUrl
        });
      } catch (err) {
        console.error('Erro ao compartilhar no navegador:', err);
      }
    } else {
      alert('Compartilhamento não suportado neste dispositivo.');
    }
  }
  analytics(uid: string, title: string) {
    this.router.navigate(['/'], { queryParams: { slick_id: uid, title: title } });
  }
  @Output() templateClicked = new EventEmitter<string>();


  confirmDeletion(uid: string): void {
    const item = this.findByUid(uid);
    if (!item) {
      console.warn('❌ Item não encontrado com UID:', uid);
      return;
    }
    let idParaDeletar = item.content.id;
    const isCarousel = item.children?.data?.length > 0;

    if (isCarousel) {
      const elements = document.querySelectorAll('[data-uid]');
      let swiperElement: any = null;

      elements.forEach((el: any) => {
        const elUid = el.getAttribute('data-uid');
        if (elUid === item.content?.uid) {
          swiperElement = el.swiper;
        }
      });

      if (!swiperElement) {
        console.warn('❌ Swiper não encontrado para UID:', uid);
        return;
      }
      const activeIndex = swiperElement.realIndex;

      if (activeIndex > 0) {
        const child = item.children?.data?.[activeIndex - 1];
        idParaDeletar = child?.content?.id;
      }
    }

    this.confirmationService.confirm({
      message: 'Você realmente deseja remover este slick?',
      header: 'Confirmação de Exclusão',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.displayDialogSidebar = true;
        this.displayAguarde = true;
        this.deletarSlick(idParaDeletar);
      }
    });
  }


  deletarSlick(n: number): void {
    this.displayDialog = true;
    this.liveShopService.DeleteSlick(n).pipe(takeUntil(this.destroy$)).subscribe({
      next: (res) => {
        this.filteredAssets.forEach((asset, index) => {
          this.filteredAssets[index].items = asset.items.filter((item: any) => item.content.id !== n);
        });

        //this.filteredAssets = this.filteredAssets.filter(asset => asset.items.length > 0);

        // Atualize outras listas, se necessário
        this.assets = [...this.filteredAssets];
        this.OriginalAssets = [...this.filteredAssets];


        // Exiba uma mensagem de sucesso
        this.messageService.add({
          severity: 'success',
          summary: 'Slick Deletado',
          detail: 'O slick foi deletado com sucesso!'
        });
        this.displayDialogSidebar = false;
        this.displayDialog = false;
        this.displayAguarde = false;
        this.slickDeleted.emit(n);
        this.groupAssetsByParent();
      },
      error: (err) => {
        this.displayAguarde = false;
        // Exiba uma mensagem de erro
        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail: 'Erro ao deletar slick.'
        });
        this.displayDialog = false;
      }
    });
  }
  private destroy$ = new Subject<void>();
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
  handleTypeChange(event: any) {
    this.selectedType = event.value;
    this.selectedTypeChange.emit(this.selectedType); // atualiza o LivesComponent
    this.onTypeSelect.emit(); // dispara o filtro
  }
  handleStatusChange(event: any) {
    this.selectedStatus = event.value;
    this.selectedStatusChange.emit(this.selectedStatus); // Atualiza o LivesComponent
    this.onStatusSelect.emit(); // Dispara o filtro
    this.clearFeedUidFromUrl();
  }
  handleDateChange(event: any) {
    this.rangeDates = event;

    const isValidRange = Array.isArray(this.rangeDates) &&
      this.rangeDates.length === 2 &&
      this.rangeDates[0] instanceof Date &&
      this.rangeDates[1] instanceof Date;

    if (isValidRange) {
      this.rangeDatesChange.emit(this.rangeDates); // Atualiza no LivesComponent
      this.onDateSelect.emit();
      this.clearFeedUidFromUrl();               // Dispara applyFilters() lá
    }
  }
  handleSourceChange(event: any) {
    this.selectedSourcesChange.emit(this.selectedSources); // atualiza o LivesComponent
    this.onSourceSelect.emit();
    this.clearFeedUidFromUrl();                          // dispara o filtro
  }
  getSourceIcon(source: string | null | undefined): string {
    if (!source) {
      return '/assets/icons/default_feed.png';
    }

    switch (source.toLowerCase()) {
      case 'uploads':
      case 'up':
        return '/assets/icons/upload_feed.jpg';
      case 'instagram':
      case 'ig':
        return '/assets/icons/instagram.webp';
      case 'tiktok':
      case 'tt':
        return '/assets/icons/tiktok.webp';
      case 'youtube':
      case 'yt':
        return '/assets/youtube-color.svg'; // coloque a imagem correta aqui
      default:
        return '/assets/icons/default_feed.png';
    }
  }


  getSourceSeverity(source: string): string {
    if (!source) {
      return 'secondary';  // valor padrão para quando não tiver source
    }
    switch (source.toLowerCase()) {
      case 'instagram': return 'instagram';
      case 'ig': return 'instagram';
      case 'tiktok': return 'tiktok';
      case 'youtube': return 'youtube';
      default: return 'secondary';
    }
  }

  handleMediaTypeChange(event: any) {
    this.selectedMediaTypes = event.value;
    this.selectedMediaTypesChange.emit(this.selectedMediaTypes); // atualiza no componente pai
    this.onMediaTypeChange.emit(); // dispara o filtro
    this.clearFeedUidFromUrl();
  }
  getMediaTypeSeverity(mediaType: string): string {
    switch (mediaType.toLowerCase()) {
      case 'reels': return 'reels';
      case 'image': return 'image';
      default: return 'secondary';
    }
  }

  handleUsageRightsChange(event: any) {
    this.selectedUsageRightsChange.emit(this.selectedUsageRights);
    this.onUsageRightsChange.emit();
    this.clearFeedUidFromUrl();
  }
  @Input() feedOptions: any[] = [];
  @Input() selectedFeeds: string[] = [];
  @Output() selectedFeedsChange = new EventEmitter<string[]>();
  @Output() onFeedSelect = new EventEmitter<void>();

  handleFeedChange(event: any) {
    this.selectedFeedsChange.emit(this.selectedFeeds);
    this.onFeedSelect.emit();
    this.clearFeedUidFromUrl();
  }

  @Input() tagOptions: { label: string; value: string }[] = [];
  @Input() selectedTags: string[] = [];
  @Output() selectedTagsChange = new EventEmitter<string[]>();
  @Output() onTagsSelect = new EventEmitter<void>();

  handleTagsChange(event: any) {
    this.selectedTagsChange.emit(this.selectedTags);
    this.onTagsSelect.emit();
  }

  // Filtro por produto associado — mesmo esquema de tagOptions/selectedTags.
  @Input() productOptions: { label: string; value: string; thumbnail?: string }[] = [];
  @Input() selectedProducts: string[] = [];
  @Output() selectedProductsChange = new EventEmitter<string[]>();
  @Output() onProductsSelect = new EventEmitter<void>();

  // Publicar/despublicar (individual ou em massa) muda o status de itens que
  // `filteredAssets` (@Input, dono é lives.component) já filtrou antes da
  // mudança — se o filtro "Status do Slick" estiver ativo, o item precisa
  // ser removido/adicionado à vista, o que exige reaplicar o filtro lá em
  // cima. Emite os uids afetados + novo status pro pai reagir.
  @Output() slicksPublishStatusChanged = new EventEmitter<{ uids: string[]; status: number }>();

  // Mesma ideia do evento acima, mas pra tags: o filtro "Tags" do dialog
  // (tagOptions, montado em lives.component a partir de filteredAssets) só
  // é recalculado quando os assets são recarregados do backend — sem esse
  // evento, uma tag nova adicionada aqui (individual ou em massa) nunca
  // aparece nas opções do filtro até dar reload na página.
  @Output() slicksTagsChanged = new EventEmitter<void>();

  handleProductsChange(event: any) {
    this.selectedProductsChange.emit(this.selectedProducts);
    this.onProductsSelect.emit();
  }

  // Tags visíveis pro lojista: exclui as fixas product_{id} geradas ao associar
  // produto ao slick (ver [[feature_product_locked_tags]]) — essas não fazem
  // sentido como chip solto no card nem como opção de filtro aqui.
  getDisplayTags(item: any): string[] {
    const raw = item?.extra?.tags;
    if (!raw) return [];
    return String(raw)
      .split(',')
      .map(t => t.trim())
      .filter(t => t && !t.startsWith('product_'));
  }

  // Edição individual de tags — botão "+ Tags" fixo no início da lista de
  // cada slick. Diferente do dialog em massa (openBulkTagsDialog/applyBulkTags,
  // que só acrescenta pra vários itens), aqui edita um slick só e permite
  // remover tag também (p-chips com as tags atuais pré-carregadas).
  individualTagsDialogVisible = false;
  individualTagsInput: string[] = [];
  loadingIndividualTags = false;
  private individualTagsItem: any = null;

  openIndividualTagsDialog(item: any): void {
    this.individualTagsItem = item;
    this.individualTagsInput = this.getDisplayTags(item);
    this.individualTagsDialogVisible = true;
  }

  applyIndividualTags(): void {
    const uid = this.individualTagsItem?.content?.uid;
    if (!uid) return;

    const tags = this.individualTagsInput.map(t => t.trim()).filter(Boolean);

    this.loadingIndividualTags = true;
    this.feedService.updateAssetTags(uid, tags).subscribe({
      next: (res: any) => {
        this.messageService.add({ severity: 'success', summary: 'Sucesso', detail: 'Tags atualizadas com sucesso' });

        const newTags = res?.tags ?? tags.join(',');
        this.applyLocalTagsMutation(uid, newTags);
        this.slicksTagsChanged.emit();

        this.loadingIndividualTags = false;
        this.individualTagsDialogVisible = false;
      },
      error: (err) => {
        this.loadingIndividualTags = false;
        this.errorHandler.handle(err, 'Falha ao atualizar tags do slick.');
      }
    });
  }

  getUnicodeIcon(tag: string): string {

    console.log('tag que entrou')
    console.log(tag)


    const t = tag.trim().toLowerCase();
    if (t.startsWith('#')) {
      return '#';                // ou '🔀', '🔖'…
    }
    if (t === 'imagens' || t === 'image') {
      return '🖼️';
    }
    if (t === 'vídeos' || t === 'videos' || t == 'video') {
      return '🎞️';
    }
    if (t === 'stories') {
      return '▯';                // U+25AF, retângulo
    }
    if (t === 'reels' || t === 'reel') {
      return '▶️';               // U+25B6, “play”
    }
    if (t === 'tag' || t === 'Tag') {
      return '🏷';               // U+25B6, “play”
    }
    if (t === 'personal_media') {
      return '🗂️';               // U+25B6, “play”
    }
    if (t === 'playlist') {
      return '📋';               // U+25B6, “play”
    }
    return '';                   // sem ícone
  }
  getTypeSeverity(type: string): string {
    switch (type) {
      case 'IMAGE': return 'info';
      case 'VIDEO': return 'help';
      case 'REEL': return 'warning';
      case 'CAROUSEL_ALBUM': return 'success';
      default: return 'secondary';
    }
  }
  //////////////////////////
  selectedItems: any[] = [];

  toggleSelection(item: any) {
    const index = this.selectedItems.findIndex(i => i.content.uid === item.content.uid);
    if (index > -1) {
      this.selectedItems.splice(index, 1);
    } else {
      this.selectedItems.push(item);
    }
  }

  isSelected(item: any): boolean {
    return this.selectedItems.some(i => i.content.uid === item.content.uid);
  }
  publicationStatusOptions = [
    { label: 'Publicado', value: 1 },
    { label: 'Não Publicado', value: 0 }
  ];

  // Pill de status (dentro do card) — mostra só o estado atual, clique abre
  // um p-menu com as opções pra trocar. `target` é o item (mídia única/pai
  // do carousel) ou o child (slide filho do carousel), cada um com seu
  // próprio media.status.
  getStatusMenuItems(target: any): any[] {
    return this.publicationStatusOptions.map(opt => ({
      label: opt.label,
      icon: opt.value === 1 ? 'pi pi-eye' : 'pi pi-eye-slash',
      command: () => this.updatePublicationStatus(target, opt.value)
    }));
  }
  @ViewChildren('swiperInstance') swipers!: QueryList<any>;

  slideToNext(uid: string): void {
    const swiper = this.findSwiperByUid(uid);
    if (swiper) {
      swiper.slideNext();
    } else {
      console.warn('❌ Swiper não encontrado para UID (next):', uid);
    }
  }

  slideToPrev(uid: string): void {
    const swiper = this.findSwiperByUid(uid);
    if (swiper) {
      swiper.slidePrev();
    } else {
      console.warn('❌ Swiper não encontrado para UID (prev):', uid);
    }
  }

  private findSwiperByUid(uid: string): any {
    const elements = Array.from(document.querySelectorAll('[data-uid]'));

    for (const el of elements) {
      if (el.getAttribute('data-uid') === uid && (el as any).swiper) {
        return (el as any).swiper;
      }
    }

    return null;
  }
  displayAguarde: boolean = false;
  loadPub: boolean = false;
  updatePublicationStatus(item: any, novoStatus: number): void {
    const uid = item.content?.uid;
    if (!uid) return;

    const uids = [uid];
    const statusOriginal = item.media.status;
    this.displayAguarde = true;
    this.loadPub = true;
    if (novoStatus === 1) {
      // Publicar
      this.feedService.publicarSelecionados(uids).subscribe({
        next: (res: any) => {
          const publicados: string[] = res?.uids_publicados ?? [];
          if (publicados.includes(uid)) {
            item.media.status = 1;
            this.slicksPublishStatusChanged.emit({ uids: [uid], status: 1 });
            this.messageService.add({
              severity: 'success',
              summary: 'Publicado',
              detail: 'Item publicado com sucesso.'
            });
          } else {
            item.media.status = 0;
            this.messageService.add({
              severity: 'warn',
              summary: 'Limite Atingido',
              detail: 'Este item não foi publicado devido ao limite do plano.'
            });
          }
          this.displayAguarde = false;
          this.loadPub = false;
          this.selectAllOnPage = false;
        },
        error: (err) => {
          this.displayAguarde = false;
          this.loadPub = false;
          this.selectAllOnPage = false;
          item.media.status = statusOriginal;
          console.log('statusOriginal: ' + statusOriginal)
          this.updateStatusInFilteredAssets(uid, 0);
          this.cdr.detectChanges();
          if (err.status === 403 && err.error?.code === 1 || err.status === 429) {
            this.handleUpgrade('feed');
          } else {
            this.messageService.add({
              severity: 'error',
              summary: 'Erro',
              detail: 'Falha ao publicar o item.'
            });
          }
        }
      });
    } else {
      // Despublicar
      this.feedService.despublicarSelecionados(uids).subscribe({
        next: () => {
          item.media.status = 0;
          this.slicksPublishStatusChanged.emit({ uids: [uid], status: 0 });
          this.messageService.add({
            severity: 'success',
            summary: 'Despublicado',
            detail: 'Item despublicado com sucesso.'
          });
          this.displayAguarde = false;
          this.loadPub = false;
          this.selectAllOnPage = false;
        },
        error: (error) => {
          this.displayAguarde = false;
          this.loadPub = false;
          this.selectAllOnPage = false;
          item.media.status = 1;
          this.errorHandler.handle(error,'Falha ao despublicar o item.');
        }
      });
    }
  }
  private updateStatusInFilteredAssets(uid: string, novoStatus: number): void {
    for (const group of this.filteredAssets) {
      const items = group.items || [];

      for (const item of items) {
        if (item.content?.uid === uid) {
          item.media.status = novoStatus;
          break;
        }
      }
    }

    this.groupAssetsByParent();
  }


  upgradeDialogTitle: string = '';
  upgradeDialogMessage: string = '';
  upgradeDialogShowActions: boolean = true;
  showUpgradeDialog: boolean = false;
  handleUpgrade(type: 'feed' | 'asset', count?: number) {

    this.upgradeDialogTitle = `Você atingiu seu limite de slicks ativos.`;

    this.upgradeDialogMessage = 'Gostaria de alterar seu plano e aumentar seus limites de uso?';
    this.upgradeDialogShowActions = true;
    // ⚠️ Se já estava aberto, força fechar e reabrir no próximo ciclo.
    this.showUpgradeDialog = false;

    // ⚠️ Deixa o Angular perceber a mudança no próximo ciclo.
    setTimeout(() => {
      this.showUpgradeDialog = true;
    });
  }

  // Resultado da publicação em massa (asset/pub já publica parcialmente até
  // a cota do plano acabar, então sempre comparamos publicados x total
  // enviado em vez de tratar só o 403 de cota zerada como "bloqueado").
  // Bug real corrigido: itens JÁ publicados também ficavam fora de
  // uids_publicados (nada pra publicar de novo, backend só pula), então
  // caíam no mesmo "balde" de itens bloqueados pelo limite do plano — um
  // usuário com cota de sobra que selecionava só itens já publicados via
  // "selecionar todos" via checkbox recebia a mensagem/dialog de upgrade
  // por engano. Agora o backend distingue os 3 casos (uids_publicados,
  // uids_ja_publicados, uids_bloqueados_cota) e só mostra o dialog de
  // upgrade quando existe algo REALMENTE bloqueado pela cota.
  private showPublishResultDialog(publishedCount: number, alreadyPublishedCount: number, blockedByQuotaCount: number): void {
    if (blockedByQuotaCount <= 0) {
      this.upgradeDialogMessage = 'Publicação de slicks';
      if (publishedCount > 0 && alreadyPublishedCount > 0) {
        this.upgradeDialogTitle = `${publishedCount} ${publishedCount === 1 ? 'item foi publicado' : 'itens foram publicados'} `
          + `(${alreadyPublishedCount} ${alreadyPublishedCount === 1 ? 'já estava publicado' : 'já estavam publicados'}).`;
      } else if (publishedCount > 0) {
        this.upgradeDialogTitle = `${publishedCount} ${publishedCount === 1 ? 'item foi publicado' : 'itens foram publicados'}.`;
      } else {
        this.upgradeDialogTitle = alreadyPublishedCount === 1
          ? 'O item selecionado já estava publicado.'
          : 'Os itens selecionados já estavam publicados.';
      }
      this.upgradeDialogShowActions = false;
    } else {
      this.upgradeDialogMessage = 'Gostaria de alterar seu plano e aumentar seus limites de uso?';
      const parts = [`${publishedCount} ${publishedCount === 1 ? 'item publicado' : 'itens publicados'}`];
      if (alreadyPublishedCount > 0) {
        parts.push(`${alreadyPublishedCount} ${alreadyPublishedCount === 1 ? 'já estava publicado' : 'já estavam publicados'}`);
      }
      parts.push(`${blockedByQuotaCount} ${blockedByQuotaCount === 1 ? 'item não publicado por limite do plano' : 'itens não publicados por limite do plano'}`);
      this.upgradeDialogTitle = parts.join(', ') + '.';
      this.upgradeDialogShowActions = true;
    }

    // ⚠️ Se já estava aberto, força fechar e reabrir no próximo ciclo.
    this.showUpgradeDialog = false;
    setTimeout(() => {
      this.showUpgradeDialog = true;
    });
  }
  irParaAssinatura(): void {
    this.router.navigate(['/profile'], { fragment: 'feed_subs' });
  }

  bottomSidebarVisible = false;

  isSelected2(item: any): boolean {
    return this.selectedItems.includes(item);
  }

  toggleSelection2(item: any): void {
    const index = this.selectedItems.indexOf(item);
    const isParent = !!item.children?.data?.length;

    if (index === -1) {
      this.selectedItems.push(item);

      // Se for um item pai com filhos, seleciona também os filhos
      if (isParent) {
        item.children.data.forEach((child: any) => {
          if (!this.selectedItems.includes(child)) {
            this.selectedItems.push(child);
          }
        });
      }
    } else {
      this.selectedItems.splice(index, 1);

      // Se for pai, remove também os filhos da seleção
      if (isParent) {
        item.children.data.forEach((child: any) => {
          const childIndex = this.selectedItems.indexOf(child);
          if (childIndex > -1) {
            this.selectedItems.splice(childIndex, 1);
          }
        });
      }
    }

    // ✅ Força recalcular status do botão
    this.possuiItensInstagram = this.getItensParaSolicitarDireitos().some(
      item => (
        ['ig'].includes((item.source_id || '').toLowerCase()) &&
        ['pending', 'rejected'].includes((item.usage_rights || '').toLowerCase())
      )
    );


    this.bottomSidebarVisible = this.selectedItems.length > 0;
  }
  possuiItensInstagram = false;

  @ViewChild('dv') dataView!: DataView;
  toggleSelectAllOnPage(): void {
    if (!this.groupedAssets || !this.dataView) return;

    const rows = (this.dataView as any).rows || 12;
    const first = (this.dataView as any).first || 0;
    const page = Math.floor(first / rows);
    const start = page * rows;
    const end = start + rows;

    const paginated = this.groupedAssets.slice(start, end); // ✅ calcula os itens atuais

    if (!Array.isArray(paginated)) return;

    if (this.selectAllOnPage) {
      for (const item of paginated) {
        this.toggleSelection2(item); // ✅ reutiliza lógica
      }
    } else {
      for (const item of paginated) {
        const index = this.selectedItems.indexOf(item);
        if (index > -1) {
          this.selectedItems.splice(index, 1);
        }

        if (item.children?.data?.length) {
          for (const child of item.children.data) {
            const childIndex = this.selectedItems.indexOf(child);
            if (childIndex > -1) {
              this.selectedItems.splice(childIndex, 1);
            }
          }
        }
      }

      // Atualiza a lista para refletir mudanças visuais
      this.selectedItems = [...this.selectedItems];
      this.bottomSidebarVisible = this.selectedItems.length > 0;


    }

    this.possuiItensInstagram = this.getItensParaSolicitarDireitos().some(
      item => (
        ['ig'].includes((item.source_id || '').toLowerCase()) &&
        ['pending', 'rejected'].includes((item.usage_rights || '').toLowerCase())
      )
    );

  }
  scrollToTop(): void {
    const container = document.querySelector('.topPage'); // ou outro seletor do topo da DataView
    if (container) {
      container.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' }); // fallback
    }
  }

  selectAllOnPage: boolean = false;

  // Referência ao paginator do DataView










  getTranslatedUsageRights(value: string): string {
    switch (value) {
      case 'approved': return 'Solicitação de direitos autorais aprovada';
      case 'waiting': return 'Aguardando solicitação de direitos autorais';
      case 'rejected': return 'Recusado';
      default: return '';
    }
  }

  getSeverityUsageRights(value: string): string {
    switch (value) {
      case 'approved': return 'success';
      case 'waiting': return 'info';
      case 'rejected': return 'danger';
      default: return 'secondary';
    }
  }

  // Ícone da p-tag de direitos de uso no grid (só ícone + tooltip com o texto,
  // ver [[feature_rights_request_mentions]]).
  getIconUsageRights(value: string): string {
    switch (value) {
      case 'approved': return 'pi pi-check';
      case 'waiting': return 'pi pi-clock';
      case 'rejected': return 'pi pi-times';
      default: return '';
    }
  }
  ///////////////////////////
  // Muta em memória o media.status dos itens já carregados (parent + children
  // de groupedAssets) em vez de recriar objetos novos via spread — os objetos
  // de groupedAssets compartilham a mesma referência de `media` com os itens
  // de filteredAssets (@Input, dono é lives.component), então mutar aqui
  // reflete lá também. Precisa disso porque só recriar groupedAssets local-
  // mente (como era antes) desconectava a cópia local da fonte real, e um
  // próximo applyFilters() no pai (ex.: limpar/reaplicar filtros) sobrescrevia
  // com o status antigo.
  private applyLocalStatusMutation(uids: string[], status: number): void {
    if (!uids.length) return;
    for (const parent of this.groupedAssets) {
      if (uids.includes(parent.content?.uid) && parent.media) {
        parent.media.status = status;
      }
      for (const child of parent.children?.data ?? []) {
        if (uids.includes(child.content?.uid) && child.media) {
          child.media.status = status;
        }
      }
    }
  }

  // Mesmo raciocínio de applyLocalStatusMutation: muta extra.tags IN PLACE
  // (em vez de reconstruir o objeto via spread) porque groupedAssets
  // compartilha a mesma referência de extra dos itens vindos de
  // filteredAssets (@Input do pai) — trocar a referência aqui desconectava
  // o dado local do dado do pai, e como tagOptions (filtro "Tags" do dialog)
  // é derivado de filteredAssets em lives.component, a tag nova nunca
  // aparecia lá.
  private applyLocalTagsMutation(uid: string, newTags: string): void {
    for (const parent of this.groupedAssets) {
      if (parent.content?.uid === uid && parent.extra) {
        parent.extra.tags = newTags;
      }
      for (const child of parent.children?.data ?? []) {
        if (child.content?.uid === uid && child.extra) {
          child.extra.tags = newTags;
        }
      }
    }
  }

  publicarSelecionados(): void {
    const uids = this.selectedItems.map(item => item.content?.uid).filter(Boolean);

    if (!uids.length) return;
    this.loadPub = true;
    this.feedService.publicarSelecionados(uids).subscribe({
      next: (res: any) => {
        const publicados: string[] = res?.uids_publicados ?? [];
        const jaPublicados: string[] = res?.uids_ja_publicados ?? [];
        const bloqueadosCota: string[] = res?.uids_bloqueados_cota ?? [];
        this.showPublishResultDialog(publicados.length, jaPublicados.length, bloqueadosCota.length);

        if (publicados.length) {
          this.applyLocalStatusMutation(publicados, 1);
          // Avisa o pai (dono de filteredAssets/assets) pra reaplicar os
          // filtros — se "Status do Slick: Publicado/Não Publicado" estiver
          // ativo, os itens que mudaram de status precisam sair/entrar da
          // lista visível agora, não só trocar de cor.
          this.slicksPublishStatusChanged.emit({ uids: publicados, status: 1 });
        }

        this.bottomSidebarVisible = false;
        this.selectedItems = [];
        this.loadPub = false;
        this.selectAllOnPage = false;
      },
      error: (error) => {
        this.loadPub = false;
        this.selectAllOnPage = false;
        if (error.status === 403 && error.error?.code === 1 || error.status === 429) {
          // Cota já estava zerada antes de tentar publicar — a seleção pode
          // ser mista (parte já publicada, parte bloqueada pela cota), o
          // backend já manda essa distinção mesmo no 403.
          const jaPublicados: string[] = error.error?.uids_ja_publicados ?? [];
          this.showPublishResultDialog(0, jaPublicados.length, uids.length - jaPublicados.length);
        } else {
          this.errorHandler.handle(error, 'Falha ao publicar os itens selecionados.');
        }
      }
    });
  }
  loadDesPub: boolean = false;
  despublicarSelecionados(): void {
    const uids = this.selectedItems.map(item => item.content?.uid).filter(Boolean);

    if (!uids.length) return;
    this.loadDesPub = true;
    this.feedService.despublicarSelecionados(uids).subscribe({
      next: () => {
        this.messageService.add({
          severity: 'success',
          summary: 'Sucesso',
          detail: 'Itens despublicados com sucesso'
        });

        this.applyLocalStatusMutation(uids, 0);
        this.slicksPublishStatusChanged.emit({ uids, status: 0 });
        this.loadDesPub = false;
        this.bottomSidebarVisible = false;
        this.selectedItems = [];
        this.selectAllOnPage = false;
      },
      error: (error) => {
        this.loadDesPub = false;
        this.selectAllOnPage = false;
        this.errorHandler.handle(error,'Falha ao despublicar os itens selecionados');
      }
    });
  }
  bulkTagsDialogVisible: boolean = false;
  bulkTagsInput: string[] = [];
  loadingBulkTags: boolean = false;

  openBulkTagsDialog(): void {
    this.bulkTagsInput = [];
    this.bulkTagsDialogVisible = true;
  }

  applyBulkTags(): void {
    const uids = this.selectedItems.map(item => item.content?.uid).filter(Boolean);
    const tags = this.bulkTagsInput.map(t => t.trim()).filter(Boolean);

    if (!uids.length || !tags.length) return;

    this.loadingBulkTags = true;
    this.feedService.addTagsToSelected(uids, tags).subscribe({
      next: () => {
        this.messageService.add({
          severity: 'success',
          summary: 'Sucesso',
          detail: 'Tags adicionadas com sucesso'
        });

        // Reflete localmente o mesmo merge case-insensitive feito no backend,
        // sem precisar recarregar a listagem inteira. Muta extra.tags IN
        // PLACE (applyLocalTagsMutation) em vez de reconstruir o objeto via
        // spread, pra não desconectar da referência compartilhada com
        // filteredAssets — ver comentário de applyLocalTagsMutation.
        const mergedTags = (currentTags: string): string => {
          const existing = String(currentTags || '').split(',').map(t => t.trim()).filter(Boolean);
          const existingLower = existing.map(t => t.toLowerCase());
          const toAppend = tags.filter(t => !existingLower.includes(t.toLowerCase()));
          return [...existing, ...toAppend].join(',');
        };

        for (const uid of uids) {
          const item = this.findByUid(uid);
          this.applyLocalTagsMutation(uid, mergedTags(item?.extra?.tags));
        }
        this.slicksTagsChanged.emit();

        this.loadingBulkTags = false;
        this.bulkTagsDialogVisible = false;
        this.bottomSidebarVisible = false;
        this.selectedItems = [];
        this.selectAllOnPage = false;
      },
      error: (error) => {
        this.loadingBulkTags = false;
        this.errorHandler.handle(error, 'Falha ao adicionar tags aos itens selecionados');
      }
    });
  }

  // Associação de produtos em massa — segue o mesmo padrão de
  // openBulkTagsDialog()/applyBulkTags(). O backend (addProductsMultiple) só
  // acrescenta os produtos que ainda não estão associados a cada slick, não
  // duplica nem substitui associações existentes.
  bulkProductsDialogVisible = false;
  bulkProductsOptions: { label: string; value: any }[] = [];
  bulkProductsSelected: any[] = [];
  loadingBulkProductsCatalog = false;
  loadingBulkProducts = false;

  openBulkProductsDialog(): void {
    this.bulkProductsSelected = [];
    this.bulkProductsDialogVisible = true;
    this.loadBulkProductsCatalog();
  }

  private loadBulkProductsCatalog(): void {
    const storeId = Number(localStorage.getItem('ss_SelectedStoreId'));

    // Reaproveita o cache já populado pela sidebar de produto único
    // (ProductCatalogCacheService), se existir — evita refazer a request.
    if (this.catalogCache.hasCacheFor(storeId)) {
      const cached = this.catalogCache.get(storeId)!;
      this.bulkProductsOptions = cached.products.map(p => ({ label: p.name, value: p }));
      return;
    }

    this.loadingBulkProductsCatalog = true;
    this.pedidosService.listProducts().then(obs => {
      obs.subscribe({
        next: (resp: any) => {
          const products = (resp.products || []).map((p: any) => transformProdutoShopify(p));
          this.bulkProductsOptions = products.map((p: any) => ({ label: p.name, value: p }));
          this.loadingBulkProductsCatalog = false;
          this.cdr.detectChanges();
        },
        error: (err: any) => {
          this.loadingBulkProductsCatalog = false;
          this.errorHandler.handle(err, 'Falha ao carregar catálogo de produtos.');
        }
      });
    }).catch((err) => {
      this.loadingBulkProductsCatalog = false;
      this.errorHandler.handle(err, 'Falha ao carregar catálogo de produtos.');
    });
  }

  applyBulkProducts(): void {
    const uids = this.selectedItems.map(item => item.content?.uid).filter(Boolean);
    if (!uids.length || !this.bulkProductsSelected.length) return;

    this.loadingBulkProducts = true;
    this.feedService.addProductsToSelected(uids, this.bulkProductsSelected).subscribe({
      next: () => {
        this.messageService.add({
          severity: 'success',
          summary: 'Sucesso',
          detail: 'Produtos associados com sucesso'
        });

        // Reflete localmente o mesmo merge "só acrescenta se ainda não
        // associado" que o backend faz, pro badge de contagem atualizar sem
        // precisar recarregar a listagem inteira (mesmo padrão de applyBulkTags).
        const mergeProducts = (contentObj: any) => {
          const existingItems = contentObj?.cta?.components?.products?.items ?? [];
          const existingSkus = new Set(existingItems.map((p: any) => String(p.sku)));
          const toAppend = this.bulkProductsSelected.filter(p => !existingSkus.has(String(p.sku)));
          if (!toAppend.length) return contentObj;
          return {
            ...contentObj,
            cta: {
              ...(contentObj?.cta ?? {}),
              components: {
                ...(contentObj?.cta?.components ?? {}),
                products: {
                  ...(contentObj?.cta?.components?.products ?? {}),
                  items: [...existingItems, ...toAppend]
                }
              }
            }
          };
        };

        this.groupedAssets = this.groupedAssets.map(parent => {
          const isParent = uids.includes(parent.content?.uid);
          const updatedChildren = parent.children?.data?.map((child: any) =>
            uids.includes(child.content?.uid) ? { ...child, content: mergeProducts(child.content) } : child
          );

          return {
            ...parent,
            content: isParent ? mergeProducts(parent.content) : parent.content,
            children: updatedChildren ? { data: updatedChildren } : parent.children
          };
        });

        this.loadingBulkProducts = false;
        this.bulkProductsDialogVisible = false;
        this.bottomSidebarVisible = false;
        this.selectedItems = [];
        this.selectAllOnPage = false;
      },
      error: (error) => {
        this.loadingBulkProducts = false;
        this.errorHandler.handle(error, 'Falha ao associar produtos aos itens selecionados');
      }
    });
  }

  confirmRemoveSelected() {
    this.confirmationService.confirm({
      message: 'Tem certeza que deseja excluir os itens selecionados?',
      header: 'Confirmação de Exclusão',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.deleteSelectedItems();
      },
      reject: () => {
        // Nenhuma ação no cancelamento
      }
    });
  }

  deleteSelectedItems() {
    const uids = this.selectedItems.map(item => item.content?.uid || item.uniq_id).filter(Boolean);

    if (!uids.length) return;

    this.feedService.deleteMultipleAssets(uids).subscribe({
      next: () => {
        this.messageService.add({ severity: 'success', summary: 'Sucesso', detail: 'Itens deletados!' });

        // 🔄 Atualiza o groupedAssets removendo os pais e filhos que estão nos uids
        this.groupedAssets = this.groupedAssets
          .filter(parent => !uids.includes(parent.content?.uid || parent.uniq_id))
          .map(parent => {
            const children = parent.children?.data?.filter((child: any) => !uids.includes(child.content?.uid || child.uniq_id));
            return { ...parent, children: children?.length ? { data: children } : null };
          })
          .filter(parent => parent); // remove qualquer nulo eventual

        this.slicksDeleted.emit(uids);
        this.selectedItems = [];
        this.bottomSidebarVisible = false;
        this.selectAllOnPage = false;
      },
      error: (error) => {
        this.errorHandler.handle(error,'Falha ao deletar itens.');
      }
    });
  }
  clearSelection(): void {
    this.selectedItems = [];
    this.bottomSidebarVisible = false;
    this.selectAllOnPage = false;
    this.selectedItems = [...this.selectedItems];
  }
  dialogDireitosVisivel: boolean = false;
  itensParaDireitosDialog: any[] = [];

  abrirDialogDireitos(item?: any): void {
    if (item) {
      this.selectedItems = [item];
    }
    this.itensParaDireitosDialog = this.getItensParaSolicitarDireitos();
    this.dialogDireitosVisivel = true;
  }

  // PrimeNG TabView calcula a posição do "ink bar" (traço abaixo da tab ativa)
  // no momento da renderização. Dentro de um p-dialog, esse momento acontece
  // com o dialog ainda invisível (largura 0), então o cálculo dá errado.
  // Depois que o dialog realmente abre, forçamos o TabView a recalcular.
  onDireitosDialogShow(): void {
    this.usageRightsRef?.recalcularTabs();
  }

  onDireitosCommentSent(event: { items: any[] }): void {
    this.marcarDireitosWaiting(event.items);
    this.dialogDireitosVisivel = false;
    this.displayAguarde = false;
    this.bottomSidebarVisible = false;
    this.clearSelection();
  }

  onDireitosSaved(event: { items: any[], keyword: string }): void {
    this.marcarDireitosWaiting(event.items);
    this.dialogDireitosVisivel = false;
  }

  private marcarDireitosWaiting(itens: any[]): void {
    for (const item of itens) {
      const uid = item?.content?.uid;
      if (!uid) continue;

      const pai = this.groupedAssets.find(i => i?.content?.uid === uid);
      if (pai) {
        pai.usage_rights = 'waiting';
        if (pai.children?.data?.length) {
          for (const child of pai.children.data) {
            child.usage_rights = 'waiting';
          }
        }
        continue;
      }

      for (const grupo of this.groupedAssets) {
        if (grupo.children?.data?.length) {
          const child = grupo.children.data.find((c: any) => c?.content?.uid === uid);
          if (child) { child.usage_rights = 'waiting'; break; }
        }
      }
    }
    this.cdr.detectChanges();
  }
  getItensParaDireitos(): any[] {
    const uniqueUids = new Set<string>();
    const resultado: any[] = [];

    for (const item of this.selectedItems) {
      if (!uniqueUids.has(item.content?.uid)) {
        resultado.push(item);
        uniqueUids.add(item.content?.uid);
      }

      if (item.children?.data?.length) {
        for (const child of item.children.data) {
          if (!uniqueUids.has(child.content?.uid)) {
            resultado.push(child);
            uniqueUids.add(child.content?.uid);
          }
        }
      }
    }

    return resultado;
  }


  getItensParaSolicitarDireitos(): any[] {
    const selecionados = this.selectedItems || [];
    const agrupados = new Map<string, any[]>();
    const isolados: any[] = [];

    for (const item of selecionados) {
      if (!item.parent_id && !item.media_id) {
        isolados.push(item);
      } else if (item.parent_id) {
        const pid = String(item.parent_id);
        if (!agrupados.has(pid)) agrupados.set(pid, []);
        agrupados.get(pid)!.push(item);
      } else if (item.media_id && item.parent_id === item.media_id) {
        agrupados.set(String(item.parent_id), [item]);
      }
    }

    const result: any[] = [...isolados];

    for (const [_, grupo] of agrupados.entries()) {
      // pega o primeiro item como representativo do post
      result.push(grupo[0]);
    }

    return result;
  }


  get textoDireitosSelecionados(): string {
    const total = this.getItensParaSolicitarDireitos().filter(
      item => (
        ['ig'].includes((item.source_id || '').toLowerCase()) &&
        ['pending', 'rejected'].includes((item.usage_rights || '').toLowerCase())
      )
    ).length;

    if (total === 0) return 'Nenhuma mídia selecionada.';
    if (total === 1) return '1 post selecionado para solicitar direitos.';
    return `${total} posts selecionados para solicitar direitos.`;
  }


  ///////////////////////////

  // ===== Filter Bar & Panel =====
  // O pill de filtros fica sempre expandido (ver .ss-l-filterbar.is-expanded
  // no template/SCSS); só o dialog com os campos de filtro abre/fecha.
  filterPanelOpen = false;

  toggleFilterPanel(): void {
    this.filterPanelOpen = !this.filterPanelOpen;
  }

  closeFilterPanel(): void {
    this.filterPanelOpen = false;
  }

  get activeFiltersCount(): number {
    let count = 0;
    if (this.rangeDates?.length === 2 && this.rangeDates[0] && this.rangeDates[1]) count++;
    if (this.selectedStatus && this.selectedStatus !== 'todos' && this.selectedStatus !== 'Status do Slick') count++;
    if (this.searchTerm?.trim()) count++;
    if (this.selectedMediaTypes?.length) count++;
    if (this.selectedSources?.length) count++;
    if (this.selectedUsageRights?.length) count++;
    if (this.selectedFeeds?.length) count++;
    if (this.selectedTags?.length) count++;
    if (this.selectedProducts?.length) count++;
    return count;
  }

  // Total de itens que a busca encontrou com os filtros atuais — filteredAssets
  // (@Input, dono é lives.component) já vem filtrado, então basta somar o
  // tamanho de items de cada grupo (normalmente um único grupo, ver
  // filterDataLocally() em lives.component.ts).
  get filteredItemsCount(): number {
    return (this.filteredAssets || []).reduce((sum, g) => sum + (g.items?.length || 0), 0);
  }

  get selectedFilterChips(): { type: string; value: any; label: string }[] {
    const chips: { type: string; value: any; label: string }[] = [];

    if (this.rangeDates?.length === 2 && this.rangeDates[0] && this.rangeDates[1]) {
      const fmt = (d: Date) => `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}`;
      chips.push({ type: 'date', value: 'range', label: `${fmt(this.rangeDates[0])} - ${fmt(this.rangeDates[1])}` });
    }

    if (this.selectedStatus && this.selectedStatus !== 'todos' && this.selectedStatus !== 'Status do Slick') {
      const opt = this.statusOptionsMap.get(this.selectedStatus);
      chips.push({ type: 'status', value: this.selectedStatus, label: opt?.label || this.selectedStatus });
    }

    if (this.searchTerm?.trim()) {
      chips.push({ type: 'search', value: this.searchTerm, label: `"${this.searchTerm.trim()}"` });
    }

    for (const v of this.selectedMediaTypes || []) {
      const opt = this.mediaTypeOptionsMap.get(v);
      chips.push({ type: 'mediaType', value: v, label: opt?.label || v });
    }

    for (const v of this.selectedSources || []) {
      const opt = this.sourceOptionsMap.get(v);
      chips.push({ type: 'source', value: v, label: opt?.label || v });
    }

    for (const v of this.selectedUsageRights || []) {
      const opt = this.usageRightsOptionsMap.get(v);
      chips.push({ type: 'usageRights', value: v, label: opt?.label || v });
    }

    for (const v of this.selectedFeeds || []) {
      const opt = this.feedOptionsMap.get(v);
      chips.push({ type: 'feed', value: v, label: opt?.username || opt?.label || v });
    }

    for (const v of this.selectedTags || []) {
      const opt = this.tagOptionsMap.get(v);
      chips.push({ type: 'tag', value: v, label: opt?.label || v });
    }

    for (const v of this.selectedProducts || []) {
      const opt = this.productOptionsMap.get(v);
      chips.push({ type: 'product', value: v, label: opt?.label || v });
    }

    return chips;
  }

  removeFilterChip(chip: { type: string; value: any }): void {
    switch (chip.type) {
      case 'date':
        this.rangeDates = null;
        this.rangeDatesChange.emit(this.rangeDates);
        this.onDateSelect.emit();
        break;
      case 'status':
        this.selectedStatus = null;
        this.selectedStatusChange.emit(this.selectedStatus);
        this.onStatusSelect.emit();
        break;
      case 'search':
        this.searchTerm = '';
        this.searchTermChange.emit(this.searchTerm);
        this.onFilterSlicks.emit({ target: { value: '' } });
        break;
      case 'mediaType':
        this.selectedMediaTypes = this.selectedMediaTypes.filter(v => v !== chip.value);
        this.selectedMediaTypesChange.emit(this.selectedMediaTypes);
        this.onMediaTypeChange.emit();
        break;
      case 'source':
        this.selectedSources = this.selectedSources.filter(v => v !== chip.value);
        this.selectedSourcesChange.emit(this.selectedSources);
        this.onSourceSelect.emit();
        break;
      case 'usageRights':
        this.selectedUsageRights = this.selectedUsageRights.filter(v => v !== chip.value);
        this.selectedUsageRightsChange.emit(this.selectedUsageRights);
        this.onUsageRightsChange.emit();
        break;
      case 'feed':
        this.selectedFeeds = this.selectedFeeds.filter(v => v !== chip.value);
        this.selectedFeedsChange.emit(this.selectedFeeds);
        this.onFeedSelect.emit();
        break;
      case 'tag':
        this.selectedTags = this.selectedTags.filter(v => v !== chip.value);
        this.selectedTagsChange.emit(this.selectedTags);
        this.onTagsSelect.emit();
        break;
      case 'product':
        this.selectedProducts = this.selectedProducts.filter(v => v !== chip.value);
        this.selectedProductsChange.emit(this.selectedProducts);
        this.onProductsSelect.emit();
        break;
    }
    this.clearFeedUidFromUrl();
  }

  trackFilterChip = (_: number, c: { type: string; value: any }) => `${c.type}:${c.value}`;
}

